import { SVGAttributes } from 'react';

type CheckProps = SVGAttributes<SVGElement> & {
  className?: string;
};

export default function Check({ className, ...props }: CheckProps) {
  return (
    <svg
      {...props}
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.29289 7.76823C3.6834 7.3658 4.31656 7.3658 4.70707 7.76823L6.2071 9.31398L11.0948 4.30182C11.4853 3.89938 12.1184 3.89938 12.5089 4.30182C12.8995 4.70425 12.8995 5.35673 12.5089 5.75916L6.9142 11.5C6.52368 11.9024 5.89053 11.9024 5.50001 11.5L3.29289 9.22558C2.90237 8.82314 2.90237 8.17067 3.29289 7.76823Z'
        fill='#232426'
      />
    </svg>
  );
}
